import { render, staticRenderFns } from "./orderStatistics.vue?vue&type=template&id=81e980ca&scoped=true&"
import script from "./orderStatistics.vue?vue&type=script&lang=js&"
export * from "./orderStatistics.vue?vue&type=script&lang=js&"
import style1 from "./orderStatistics.vue?vue&type=style&index=1&id=81e980ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e980ca",
  null
  
)

export default component.exports